import { Divider, Form, Typography } from "antd";
import {
  ActionButtonGroup,
  ActionButtonGroupProps,
  CInfiniteScroll,
  CInfiniteScrollProps,
} from "components";
import { CInputDebounce } from "components/input/c-input";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import tw from "twin.macro";

const Wrapper = styled.div`
  ${tw`bg-white shadow`}
  height:calc(100vh - 151px);
`;

export interface InfiniteProps extends CInfiniteScrollProps {
  search?: {
    title?: string;
    placeholder?: string;
    onChange: (value: string) => void;
  };
}

interface InfiniteSidebarProps {
  title: string;
  content?: ReactNode;
  infiniteScroll?: InfiniteProps;
  actionButtonGroup?: ActionButtonGroupProps;
  heightContent?: string;
}

export const InfiniteSidebar: React.FC<InfiniteSidebarProps> = ({
  title,
  content,
  infiniteScroll,
  actionButtonGroup,
  heightContent = "calc(100vh - 224px)",
}) => {
  const { t } = useTranslation();
  const { search } = infiniteScroll || {};

  const getHeight = () => {
    if (infiniteScroll?.search && actionButtonGroup) {
      return "calc(100vh - 391px)";
    }
    if (infiniteScroll?.search) {
      return "calc(100vh - 331px)";
    }
    if (actionButtonGroup) {
      return "calc(100vh - 291px)";
    }
    if (!infiniteScroll?.search && !actionButtonGroup) {
      return "calc(100vh - 221px)";
    }
    return 0;
  };

  const infiniteHeight = getHeight();
  return (
    <Wrapper>
      <div className="p-5">
        <Typography.Title
          ellipsis={{ tooltip: title }}
          level={5}
          className="!text-primary-dark"
        >
          {title}
        </Typography.Title>
      </div>
      <Divider className="!m-0" />
      <Form
        hidden={!!content || (!actionButtonGroup && !infiniteScroll)}
        layout="vertical"
        className="!px-5 !pt-5"
      >
        <Form.Item hidden={!actionButtonGroup} className="!mb-5">
          <ActionButtonGroup {...actionButtonGroup} />
        </Form.Item>
        <Form.Item
          hidden={!infiniteScroll?.search}
          className="!mb-5"
          label={search?.title || t("search")}
          name="search"
        >
          <CInputDebounce
            search
            placeholder={search?.placeholder || `${t("search")}`}
            onChange={(e) => {
              const { onChange } = infiniteScroll?.search || {};
              onChange?.(e);
            }}
          />
        </Form.Item>
      </Form>
      {infiniteScroll && (
        <CInfiniteScroll height={infiniteHeight} {...infiniteScroll} />
      )}
      <div
        hidden={!content}
        className="p-5"
        style={{ height: heightContent, overflow: "auto" }}
      >
        {content}
      </div>
    </Wrapper>
  );
};
